import { designerNodeOrNullSelector, useNautilusSelector } from "../../state";
import type { DesignerNodeHandle } from "../../types";
import { TriggersDesigner } from "./TriggersDesigner";

type TriggersPropertiesProps = {
  node: DesignerNodeHandle;
};

export const TriggersPropertiesView = ({ node }: TriggersPropertiesProps) => {
  const fullNode = useNautilusSelector((state) => designerNodeOrNullSelector(state, { nodeId: node.id }));
  if (!fullNode) return null;
  return <TriggersDesigner node={fullNode} />;
};
